import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const TIPPING_BASE_URL = ConfigurationService.get(ConfigurationKeys.TIPPING_BASE_URL);
const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const TIPPING_POLLING_URL = `${TIPPING_BASE_URL}/tipper/tipping.user.php`;
export const TIPPING_OPERATION_URL = `${BASE_URL}/tippingOperation`;
export const PRIVATE_TIPPING_URL = `${BASE_URL}/rest/v1.0/profile/{username}/privateTip`;
export const FANCLUB_PRIVATE_TIPPING_URL = `${BASE_URL}/rest/v1.0/partner/fanclubs/{username}/tip`;
